export const selectResult = (state) => state.currentTransaction.result;
export const selectError = (state) => state.currentTransaction.error;
export const selectLoading = (state) => state.currentTransaction.loading;
